import { ApiError } from './api';

/** Turn API and network errors into a user-visible login/setup message. */
export function formatAuthError(err: unknown, needsSetup: boolean): string {
  if (err instanceof ApiError) {
    if (err.code === 'validation_error' && err.details) {
      const flat = err.details as {
        fieldErrors?: Record<string, string[]>;
        formErrors?: string[];
      };
      const fieldMsgs = Object.entries(flat.fieldErrors ?? {}).flatMap(([field, msgs]) =>
        msgs.map((m) => `${field}: ${m}`),
      );
      const all = [...(flat.formErrors ?? []), ...fieldMsgs];
      if (all.length) return all.join(' ');
    }
    return err.message;
  }
  if (err instanceof TypeError) {
    return 'Could not reach the server. Check that the API is running and your network connection.';
  }
  return needsSetup
    ? 'Could not create the administrator account. Please try again.'
    : 'Could not log in. Please try again.';
}
